export function filterArrayByArray(array, values, fieldName) {
    if (!values || !values.length) return [];

    if (!fieldName) throw new Error("filterArrayByArray: не указано поле для фильтрации");
    if (!Array.isArray(array)) throw new Error("filterArrayByArray: параметр array не является массивом");

    const _array = array.map((item) => ({
        item,
        matches: false,
    }));

    values.forEach((value) => {
        const item = _array.find((el) => {
            if (el.matches) return false;
            return el.item[fieldName] === value;
        });

        if (item) item.matches = true;
    });

    return _array.filter((item) => item.matches).map((item) => item.item);
}
